import { MarketplaceChannelLogDetailPage } from "@/features/marketplace-channel-log/pages/MarketplaceChannelLogDetailPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/admin/marketplace-channel-log/$id/detail",
)({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({
				permissions: ["marketplace_channel_api_logs.view"],
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: MarketplaceChannelLogDetailPage,
});
